import { api } from "./api";
import {
  TCreateTokenRequest,
  TCreateTokenResponse,
  TCheckCardRequest,
  TCheckCardResponse,
  TRemoveCardRequest,
  TRemoveCardResponse,
} from "../types/payment.types";

export const paymentApi = api.injectEndpoints({
  endpoints: (build) => ({
    createPaymentToken: build.mutation<TCreateTokenResponse, TCreateTokenRequest>({
      query: (body) => ({
        url: `Payments/GetPaymentPage`,
        method: "POST",
        body,
      }),
    }),
    checkCard: build.query<TCheckCardResponse, TCheckCardRequest>({
      query: ({ userGuid }) => ({
        url: `User/CheckAndEditUserToken/${userGuid}/1`,
        method: "GET",
        responseHandler: (response) => response.text(),
      }),
      transformResponse: (response: string) => {
        // Handle "false" string or actual card digits
        if (response === "false" || response === "False") {
          return false;
        }
        return response;
      },
    }),
    removeCard: build.mutation<TRemoveCardResponse, TRemoveCardRequest>({
      query: ({ userGuid }) => ({
        url: `User/CheckAndEditUserToken/${userGuid}/2`,
        method: "GET",
      }),
    }),
  }),
});

export const { 
  useCreatePaymentTokenMutation,
  useCheckCardQuery,
  useRemoveCardMutation,
} = paymentApi;

